import React from 'react';
import { TablePagination } from "@mui/material";
import { PageableParams } from "../../../../types/model/params/PageableParams";
import { PageInfo } from "../../../../types/common/Pagination";
import { SecurSpaceReportPaginationContainer } from "../../reports";

type BoundTablePaginationProps<T> = {
  visible: boolean;
  pageInfo?: PageInfo;
  onChange: (value: T) => void;
}

const BoundTablePagination = <T extends PageableParams>({
  visible,
  pageInfo,
  onChange
}: BoundTablePaginationProps<T>) => {

  const handlePageChange = (_: any, newPage: number) => {
    onChange({
      page: newPage
    } as T);
  }

  const handleRowsPerPageChange = (event: any) => {
    onChange({
      size: Number(event.target?.value)
    } as T);
  }

  return visible && <SecurSpaceReportPaginationContainer>
    <TablePagination
      component={'div'}
      count={pageInfo?.count || 0}
      page={pageInfo?.page || 0}
      onPageChange={handlePageChange}
      rowsPerPage={pageInfo?.rowsPerPage || 0}
      onRowsPerPageChange={handleRowsPerPageChange}
    />
  </SecurSpaceReportPaginationContainer>
}

export { BoundTablePagination };